module.exports = __webpack_public_path__ + "img/shap.1877859e.png";